import React, { lazy } from 'react';
import { Route } from 'react-router';

const EventsOverview = lazy(() =>
  import('@pages/Portal/Events/Overview').then((m) => ({
    default: m.EventsOverview,
  }))
);

export const portalEventsRoutes = (
  <Route path="events">
    <Route index element={<EventsOverview />} />
  </Route>
);
